const riskAssessmentSetupTabs = {
    TEMPLATES: "templates",
    SHARE_GROUPS: "shareGroups",
    BRANDING: "branding",
};

export default riskAssessmentSetupTabs;
